import { render } from "./RcsOnboardingWizard.vue?vue&type=template&id=680717e4"
import script from "./RcsOnboardingWizard.vue?vue&type=script&lang=ts"
export * from "./RcsOnboardingWizard.vue?vue&type=script&lang=ts"

import "./RcsOnboardingWizard.vue?vue&type=style&index=0&id=680717e4&lang=scss"
script.render = render

export default script